<template>
    <el-dialog
        title="隐私政策"
        center
        append-to-body
        v-model="visible"
        class="user-protocol"
        width="600px">
        <div class="user-privacy">
            <el-scrollbar style="height: 600px;">
                <p class="user-privacy-version">版本日期:2024年1月</p>
                <div class="user-privacy-content">
                    <p class="title">用户协议和隐私政策</p>
                    <p>用户协议和隐私政策是小程序开发者为保障用户合法权益和保护用户隐私而制定的两个重要文件。下面分别介绍一下小程序用户协议和隐私政策的内容和要点:</p>
                    <p class="heavy">用户协议</p>
                    <p>用户协议是小程序开发者与用户之间达成的协议，规定了用户使用小程序的条件、权利和义务等内容。用户在使用小程序之前需要同意用户协议，否则无法使用小程序。一般来说，小程序用户协议包括以下几个方面的内容:</p>
                    <p>1.用户注册和账号管理规定:包括用户注册、账号安全和管理等规定。</p>
                    <p>2.使用规和限括户小程上发布内容的规范、禁止发布的内容和行为等规定。</p>
                    <p>3.用户权利和义务:包括用户在使用小程序时享有的权利和应承担的义务等规定。</p>
                    <p>4.免责声明和责任限制:包括小程序开发者对小程序服务的免责声明和责任限制等规定。</p>
                    <p>5.争议解决方式:包括双方在发生争议时解决方式的规定。</p>
                    <p class="heavy">隐私政策</p>
                    <p>隐私政策是小程序开发者为保护用户隐私而制定的政策，规定了小程序开发者在收集、使用、存储、保护用户个人信息时应遵守的原则和措施。用户在使用小程序时，需要同意隐私政策，否则无法使用小程序。一般来说，小程序隐私政策包括以下几个方面的内容:</p>
                    <p>1.收集和使用用户个人信息的范围和目的:包括小程序开发者收集和使用哪些用户个人信息、为什么收集和使用这些信息等说明。</p>
                    <p>2.个人信息的保护和管理:包括小程序开发者如何保护和管理用户个人信息，以及如何处理用户请求删除、更正、撤回同意等要求的规定。</p>
                    <p>3.信息共享和披露:包括小程序开发者在哪些情况下会共享或披露用户个人信息的规定。</p>
                    <p>4.Cookie和类似技术的使用:包括小程序开发者在使用Cookie和类似技术时应遵守的规定。</p>
                    <p>5.隐策的更和变更:包括小程序开发者如何更新和变更隐私政策，以及用户如何获 得通知和选择的规定。</p>
                    <p>以上是用户协议和隐私政策的主要内容和要点。由于各个小程序的具体情况和需求不同，开发者需要根据实际情况制定相应的用户协议和隐私政策，以保障用户合法权益和保护用户隐私。同时，在制定协议和政策时，开发者也需要考虑法律法规和相关规定的要求，以确保协议和政策的合法性和有效性。</p>
                    <p>除了制定协议和政策外，小程序开发者还需要确保用户在使用小程序时的知情权和选择权。在用户协议和隐私政策中，应当详细说明用户的权利和义务，并让用户明确知道自己的个人信息将会被收集和使用。同时，用户应当有权选择是否同意协议和政策，以及随时撤回同意或删除个人信息的权利。</p>
                    <p>最后，小程序开发者还需要建立健全的个人信息保护机制，确保用户个人信息的安全和保密。开发者应当采取技术措施和管理措施，防止用户个人信息被泄露、丢失或被滥用。对于个人信息安全事件的处理，开发者应当及时采取应对措施，并向用户说明情况，以及依法履行相关报告和告知义务。</p>
                    <p>综上所述，小程序用户协议和隐私政策是保障用户合法权益和保护用户隐私的重要文件。小程序开发者需要认真制定协议和政策，并确保用户在使用小程序时的知情权和选择权，同时建立健全的个人信息保护机制，确保用户个人信息的安全和保密。</p>
                </div>
            </el-scrollbar>
        </div>
    </el-dialog>
</template>

<script>
export default {
    // 组件名称
    name: 'protocolPage',
    // 组件参数 接收来自父组件的数据
    props: {
        isView: {
            type: Boolean,
            default: false
        }
    },
    // 组件状态值
    data() {
        return {
            visible: false,
            userList: [],
            curUser: {}
        }
    },
    // 计算属性
    computed: {
        heightValue() {
            let len = this.userList.length
            if (len === 1) {
                return '108px'
            } else if (len <= 3) {
                return `${((len - 1) * 24) + (len * 108)}px`
            } else {
                return '372px'
            }
        }
    },
    // 侦听器
    watch: {
        isView: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.visible = true
                }
            }
        },
        visible: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.$emit('update:isView', false)
                }
            }
        }
    },
}
</script> 

<style scoped lang="scss">
.user-protocol {
    ::v-deep .el-dialog__header {
        padding: 20px 20px 10px;
    }
    ::v-deep .el-dialog__body {
        padding: 10px 20px 20px;
        .user-privacy {
            p {
                font-size: 14px;
                line-height: 26px;
                color: #666;
                text-indent: 28px;
            }
        }
    }
}
</style>
